import namespace from "@rdf-esm/namespace";
const builder = namespace("https://gs1.org/voc/");
export const strict = builder;
export const loose = builder;